<template>
    <div class="agreement-content">
        <div class="agreement-container">
            <div class="container-title">协议信息</div>
            <div class="container-body" >
                <el-form label-width="100px" :inline="true">
                    <el-col :span="12">
                        <el-form-item label="协议编号:">
                            <div class="ellipsis" >{{agreementDetail.agreementCode}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="协议名称:">
                            <div  class="ellipsis" >{{agreementDetail.agreementName}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="协议甲方企业:">
                            <div   class="ellipsis" >{{agreementDetail.firstParty}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="供应商企业:">
                            <div   class="ellipsis" >{{agreementDetail.supplierCompanyName}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12"  v-if="!agreementOrigin">
                        <el-form-item label="协议有效时间:" prop="date">
                            <div   class="ellipsis" >{{agreementDetail.startDate + '至' + agreementDetail.endDate}}</div>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12"  v-if="agreementOrigin">
                        <el-form-item label="协议有效时间:" prop="date">
                            <div   class="ellipsis" >{{agreementDetail.startDate + '至' + agreementDetail.endDate}}</div>
                        </el-form-item>
                    </el-col>
<!--                    0 集采 ,1 非集采-->
                    <el-col :span="12" v-if="Number(agreementDetail.collectType) === 0">
                        <el-form-item label="协议类型:">
                            <div class="ellipsis flex">
                                集采
                                <span class="margin-l20">服务费率：{{agreementDetail.serviceRate}}%</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12"  v-if="agreementOrigin">
                        <el-form-item label="备注:" prop="remark">
                            <div   class="ellipsis" >{{agreementDetail.remark}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="Number(quickNavActive) === 1" style="margin: 20px 0">
                        <e-search
                                :data="filterInfo.data"
                                :field-list="filterInfo.fieldList"
                                @handleFilter="handleSearch"
                                @handleReset="handleClear"
                        ></e-search>
                    </el-col>
                    <el-col :span="24">
                        <el-tabs class="tabs-area" v-model="quickNavActive" type="card">
                            <el-tab-pane label="采购执行企业" name="0">
                                <div class="scrollbar">
                                    <el-scrollbar wrap-style="overflow-x:hidden;" style="height: 100%;">
                                        <TableList
                                                :loading="loading"
                                                :table-data="tableData"
                                                :table-label="tableLabel"
                                                :index-show="indexShow"
                                                @handleButton="handleButton"
                                                @handleSortChange="handleSortChange"
                                                @handleSelectionChange="handleSelectionChange"
                                        ></TableList>
                                    </el-scrollbar>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="采购协议物料类别" name="1"  v-if="!agreementOrigin">
                                <div class="scrollbar">
                                    <el-scrollbar wrap-style="overflow-x:hidden;" style="height: 100%;">
                                        <div class="table">
                                            <TableList
                                                    style="width: 50%"
                                                    :loading="loading2"
                                                    :table-data="tableData3"
                                                    :table-label="tableLabel2"
                                                    :index-show="false"
                                                    @handleButton="handleButton"
                                                    @handleSortChange="handleSortChange"
                                                    @handleSelectionChange="handleSelectionChange"
                                                    key="1"
                                            >
                                            </TableList>
                                            <TableList
                                                    style="width: 50%"
                                                    :loading="loading2"
                                                    :table-data="tableData2"
                                                    :table-label="tableLabel2"
                                                    :index-show="false"
                                                    @handleButton="handleButton"
                                                    @handleSortChange="handleSortChange"
                                                    @handleSelectionChange="handleSelectionChange"
                                                    key="2"
                                            >
                                            </TableList>
                                        </div>

                                    </el-scrollbar>
                                </div>
                            </el-tab-pane>
                        </el-tabs>

                    </el-col>

                    <el-col :span="24" v-if="!agreementOrigin">
                        <el-form-item label="备注:">
                            <el-input type="textarea" disabled v-model="agreementDetail.remark" style="width: 725px; height: 60px"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24"  v-if="!agreementOrigin">
                        <el-form-item label="附件:">
                            <div style="color:#0064C8; cursor: pointer;display: flex; align-items: center" v-for="(item,index) in agreementDetail.agreementAttachment" @click="handleDownload(item.attachmentPath)" :key="index">
                                <img style="width: 12px;height: 16px;margin-right: 12px" src="../../../../assets/img/agreement/file.png"/>{{item.attachmentName}}
                            </div>
                        </el-form-item>
                    </el-col>

                </el-form>

            </div>
        </div>

        <div class="agreement-container" v-if="!agreementOrigin">
            <div class="container-title">协议商品信息</div>

            <div class="container-body">
                <div style="margin-right: 20px">
                    <TableList
                            :loading="loading1"
                            :table-data="tableData1"
                            :table-label="tableLabel1"
                            :index-show="indexShow"
                            @handleButton="handleButton1"
                            @handleSortChange="handleSortChange1"
                            @handleSelectionChange="handleSelectionChange1"
                    >
                        <template v-slot:image="slot">
                            <img :src="slot.scope.row.defaultImage" style="width: 48px;height: 48px" />
                        </template>
                        <template v-slot:rate="slot">
                            {{slot.scope.row.price ? (slot.scope.row.agreementPrice ? formatRate(slot.scope.row) : '') : '-'}}
                        </template>
                        <template v-slot:status="slot">
                            {{formatStatus(slot.scope.row.status)}}
                        </template>
                    </TableList>
                    <div class="pagination">
                        <el-pagination
                                prev-text="上一页"
                                next-text="下一页"
                                @size-change="handleSizeChange1"
                                @current-change="handleCurrentChange1"
                                :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                                layout="total, sizes, prev, pager, next, jumper"
                                :current-page="productTagPage1.currentPage"
                                :page-size="productTagPage1.pageSize"
                                :total="productTagPage1.pageTotal"
                        >
                        </el-pagination>
                    </div>
                </div>

            </div>


        </div>
        <div class="agreement-container" v-else>
            <div class="container-title">采购协议物料清单
            </div>
            <div class="container-body">
                <div style="margin-right: 20px">
                    <TableList
                            :loading="loading3"
                            :table-data="tableData4"
                            :table-label="tableLabel4"
                            :index-show="true"
                            @handleButton="handleButton3"
                            @handleSortChange="handleSortChange3"
                            @handleSelectionChange="handleSelectionChange3"
                    >
                        <template v-slot:materialCode="slot">
                            <div style="cursor: pointer;color: #0064C8;font-size: 12px;text-align: left;" class="in2clamp" @click="checkProduct(slot.scope.row)" >
                                {{slot.scope.row.materialCode}}
                            </div>
                        </template>
                        <template v-slot:isAddProduct="slot">
                            <div class="table-product-name">
                                {{formateAddProduct(slot.scope.row.hasSku)}}
                            </div>

                        </template>
                    </TableList>
                    <div class="pagination">
                        <el-pagination
                                @size-change="handleSizeChange3"
                                @current-change="handleCurrentChange3"
                                :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                                layout="total, sizes, prev, pager, next, jumper"
                                :current-page="pager.currentPage"
                                :page-size="pager.pageSize"
                                :total="pager.pageTotal"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-button @click="handleCancel">返回</el-button>
        </div>
        <el-dialog
                :append-to-body="true"
                :visible.sync="categoryVisible"
                width="1200px"
                :close-on-click-modal="false"
        >


<!--            <el-button style="float: right;margin-bottom: 10px" type="primary" v-if="editFlag" @click="handleAddProduct">新增</el-button>-->
            <div>
                <TableList
                        :loading="loading1"
                        :table-data="tableData1"
                        :table-label="tableLabel5"
                        :index-show="true"
                        @handleButton="handleButton1"
                        @handleSortChange="handleSortChange1"
                        @handleSelectionChange="handleSelectionChange1"
                >
                    <template v-slot:skuName="slot">
                        <div class="table-product-name">
                            {{slot.scope.row.skuName}}
                        </div>

                    </template>
                    <template v-slot:image="slot">
                        <img :src="slot.scope.row.defaultImage"  style="width: 48px;height: 48px;border:1px solid #D9D9D9;" />
                    </template>
                    <template v-slot:rate="slot">
                        {{slot.scope.row.price ? (slot.scope.row.agreementPrice ? formatRate(slot.scope.row) : '') : '-'}}
                    </template>
                    <template v-slot:status="slot">
                        {{formatConfirmStatus(slot.scope.row.confirmStatus)}}
                    </template>
                    <template v-slot:operateSign="slot">
                        {{formatOperateSign(slot.scope.row.operateSign)}}
                    </template>
                    <template v-slot:operation="slot">
                        <el-button type="text" @click="handleDelete(slot.scope.row)">删除</el-button>
                    </template>
                </TableList>
                <div class="pagination">
                    <el-pagination
                            @size-change="handleSizeChange1"
                            @current-change="handleCurrentChange1"
                            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page="productTagPage1.currentPage"
                            :page-size="productTagPage1.pageSize"
                            :total="productTagPage1.pageTotal"
                    >
                    </el-pagination>
                </div>

                <div style="text-align: center">
                    <el-button @click="handleCancelEdit">取消</el-button>
                </div>
            </div>


        </el-dialog>
    </div>
</template>

<script>
    import TableList from '../../components/common/e-table-list'
    import Api from '../../api/agreement/index'
    import ESearch from '../../components/common/e-search';
    export default {
        name: "agreementDetail",
        components: {
            TableList,
            ESearch
        },
        props: {
        },
        data() {
            return {
              filterInfo: {
                data: {
                  categoryName:null,
                },
                fieldList: [
                  {label: '物料类别', type: 'input', value: 'categoryName'},
                ],
              },
                agreementDetail:'',
                loading:false,
                tableData:[],
                tableLabel: [
                    { label: '企业名称', param: 'companyName', align: 'center'},
                ],
                loading1:false,
                tableData1:[
                ],
                tableLabel1: [
                    { label: '图片', param: 'defaultImage', align: 'center', slot:'image'},
                    { label: '商品名称', param: 'skuName', align: 'center' },
                    { label: '商品编号', param: 'skuCode', align: 'center'},
                    { label: '计量单位', param: 'unitValue', align: 'center'},
                    { label: '协议价（元）', param: 'agreementPrice', align: 'center'},
                    { label: '市场价（元）', param: 'price', align: 'center'},
                    { label: '优惠比例', param: 'rate', align: 'center',slot:'rate'},
                    { label: '确认状态', param: 'status', align: 'center',slot:'status'},
                ],
                productTagPage1: {
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                agreementConfirm:1,
                indexShow:true,
                loading2:false,
                tableData2:[],
                tableData2All:[],
                tableLabel2: [
                    { label: '序号', param: 'index', align: 'center',width:'50px'},
                    { label: '物料类别', param: 'categoryName', align: 'center'},
                ],
                productTagPage2: {
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                tableData3:[],
                tableData3All:[],
                operatingCompany:'',
                quickNavActive:0,
                loading3:false,
                tableData4:[
                    // {categoryId:1001,categoryName:"低合金工字钢",categoryCode:'232423',isAdd:0,unitValue:'个'},
                ],
                tableLabel4: [
                    { label: '物料编码', param: 'materialCode', align: 'center',slot:'materialCode'},
                    { label: '物料名称', param: 'materialName', align: 'center'},
                    { label: '物料描述', param: 'materialDesc', align: 'center'},
                    { label: '是否添加商品', param: 'hasSku',width:'200', align: 'center',slot:'isAddProduct'},
                ],
                pager: {
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                agreementOrigin: false,//false代表正常创建的协议，true代表从其他平台推送过来的协议
                materialCode:'',
                categoryVisible:false,
                editFlag:false,
                tableLabel5: [
                    { label: '图片', param: 'defaultImage', align: 'center', slot:'image'},
                    { label: '商品名称', param: 'skuName', align: 'center', slot:'skuName' },
                    { label: '商品编号', param: 'skuCode', align: 'center',},
                    { label: '计量单位', param: 'unitValue', align: 'center',},
                    { label: '协议价（元）', param: 'agreementPrice',width:'200', align: 'center'},
                    { label: '市场价（元）', param: 'price', align: 'center',},
                    { label: '优惠比例', param: 'rate', align: 'center',slot:'rate'},
                    // { label: '协议价状态', param: 'status', align: 'center',slot:'status'},
                ],
              queryData:{
                categoryName:'',
              },
            }
        },
        computed: {},
        created() {
            // this.agreementDetail = this.$route.params.agreementDetail
            // this.tableData = this.agreementDetail.agreementMembers
            this.getAgreementDetail()
            // this.getEpecProductPriceList()
            this.getMdmTypeList()
            // this.getCompanyName()
        },
        methods: {
          //前端筛选
          multiFilter(array, filters){
            const filterKeys = Object.keys(filters);
            return array.filter((item) => {
              return filterKeys.every(key => {
                if(!filters[key].length) return true
                return !!~item[key].indexOf(filters[key])
              })
            })
          },
          handleSearch(val){
             this.queryData.categoryName = val.categoryName;
              this.tableData2 = this.multiFilter(this.tableData2,this.queryData)
              this.tableData3 = this.multiFilter(this.tableData3,this.queryData)
          },
          handleClear(){
            this.queryData.categoryName = '';
            this.tableData2 = this.tableData2All;
            this.tableData3 = this.tableData3All;
          },
            handleButton(){
            },
            handleSortChange(){},
            handleSelectionChange(){},
            handleButton1(){
            },
            handleSortChange1(){},
            handleSelectionChange1(){},
            handleSizeChange1(val){
                this.productTagPage1.pageSize = val
                this.productTagPage1.currentPage = 1
                this.getEpecProductPriceList()
            },
            handleCurrentChange1(val){
                this.productTagPage1.currentPage = val
                this.getEpecProductPriceList()
            },
            formatRate(val){
                return ((((val.price - val.agreementPrice) / val.price) * 100).toFixed(2)) + '%'
            },
            formatStatus(){
                return '已确认'
            },
            getEpecProductPriceList(){
                let params = {
                    agreementId: this.$route.query.agreementId,
                    pageSize:this.productTagPage1.pageSize,
                    pageNum: this.productTagPage1.currentPage,
                    supplierCompanyId : this.agreementDetail.supplierCompanyId,
                    materialCode: this.agreementOrigin ? this.materialCode : ''
                }
                Api.getEpecProductPriceList(params)
                    .then((res) => {
                        if(res.data){
                            this.tableData1 = res.data.records
                            this.productTagPage1.pageTotal = res.data.total
                        }
                    })
            },
            getMdmTypeList(){
                let params = {
                    agreementId:this.$route.query.agreementId,
                }

                Api.getMdmTypeList(params)
                    .then((res) => {
                        if(res.data){
                            for(let i=0;i<res.data.length;i++){
                                if((i+1) % 2 == 0){
                                    this.$set(res.data[i],'index', i+1)
                                    this.tableData2.push(res.data[i])
                                    this.tableData2All = this.tableData2;
                                }else {
                                    this.$set(res.data[i],'index', i+1)
                                    this.tableData3.push(res.data[i]);
                                    this.tableData3All = this.tableData3;
                                }
                            }

                        }
                    })
            },
            getCompanyName(){
                let params = {
                companyId:this.agreementDetail.epecBelongCompanyId
                }
                Api.getCompanyName(params)
                    .then((res) => {
                        if(res.data){
                            this.operatingCompany = res.data.companyName
                        }
                    })
            },
            handleDownload(val){
                window.open(val);
            },
            async getAgreementDetail(){
                let params = {
                    agreementId: this.$route.query.agreementId
                }
                let res = await Api.getAgreementDetail(params)
                        if(res.data){
                            this.agreementDetail = res.data
                            this.agreementOrigin = res.data.source ? (this.agreementDetail.source == 'SL' || this.agreementDetail.source == 'SC') : false
                            this.tableData = this.agreementDetail.agreementMembers
                        }
                if(!this.agreementOrigin){//如果商品是正常创建的就调接口
                    this.getEpecProductPriceList()
                }else {//如果是从SCM推送过来的
                    this.getCategoryList()
                }
            },
            handleCancel(){
                this.goToUrl()
            },
            goToUrl () {
                this.$store.state.tagsList.map((item, index) => {
                    if (item.fullPath == this.$route.path) {
                        this.$store.state.tagsList.splice(index, 1);
                    }
                })
                this.$router.go(-1);
            },
            handleButton3(){
            },
            handleSortChange3(){},
            handleSelectionChange3(){},
            handleSizeChange3(val){
                this.pager.pageSize = val
                this.pager.currentPage = 1
                this.getCategoryList()
            },
            handleCurrentChange3(val){
                this.pager.currentPage = val
                this.getCategoryList()
            },
            async getCategoryList(){
                let params = {
                    agreementId: this.$route.query.agreementId,
                    pageSize: this.pager.pageSize,
                    pageNum: this.pager.currentPage
                }
                let res = await Api.getCategoryList(params)

                if(res.data){
                    this.tableData4 = res.data
                    this.pager.pageTotal = res.data.total
                }
            },
            formateAddProduct(val){
                if(val == false){
                    return '否'
                }else {
                    return '是'
                }
            },
            checkProduct(row){
                this.categoryVisible = true
                this.materialCode = row.materialCode
                this.getEpecProductPriceList()
            },
            handleCancelEdit(){
                this.categoryVisible = false
            },
            formatConfirmStatus(val){
                let res = ''
                switch (val) {
                    case 0: res='未提交';break;
                    case 1: res='待确认';break;
                    case 2: res='已确认';break;
                    case 3: res='拒绝'; break;
                }
                return res;
            },
            formatOperateSign(val){
                let res = ''
                switch (val) {
                    case 0: res='新增';break;
                    case 1: res='调价';break;
                    case 2: res='删除';break;
                }
                return res;
            },
        }

    }
</script>

<style lang="scss" scoped>
    .agreement-content{
        display:flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .agreement-container{
            background: #fff;
            margin-bottom: 10px;
            box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px 20px;
            .container-title{
                font-size: 16px;
                color: #333;
                margin-bottom: 20px;
                width: 100%;
            }
            .container-body{
                width: 100%;
                .el-input-width{
                    width: 266px;
                    height: 28px;
                }
                .container-purchase{
                    background: #F8F8F8;
                    width: 725px;
                    height: 424px;
                    padding: 20px;
                    display: flex;
                    flex-direction: column;
                    .left{
                        width: 308px;
                        height: 360px;
                        background-color: #FFFFFF;
                        padding: 10px 10px 10px;
                        .search{
                            width: 100%;
                            .scrollbar{
                                height: 242px;
                                overflow: hidden;
                            }
                        }
                    }
                    .right{
                        width: 298px;
                        height: 360px;
                        background-color: #FFFFFF;
                        padding: 10px 10px 10px;
                        .scrollbar{
                            height: 316px;
                            overflow: hidden;
                            .scrollbar-li{
                                display: flex;
                                justify-content: space-between;
                                cursor: pointer
                            }
                            .scrollbar-active{
                                background: #F4F7FF;
                            }
                        }
                    }
                    .middle{
                        width: 60px;
                        height: 360px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img{
                            height: 35px;
                            width: 18px;
                        }
                    }
                    .tip{
                        font-size: 14px;
                        color: #999999;
                    }
                }
                .tabs-area{
                    margin-bottom: 20px;
                    .scrollbar{
                        height: 290px;
                        overflow: hidden;
                        .table{
                            display: flex;
                            flex-direction: row;
                        }
                    }
                }
            }

        }
    }

    .scrollbar ::v-deep .el-scrollbar__wrap{
        overflow: hidden;
        margin-right: 0 !important;
    }
    .scrollbar ::v-deep .el-scrollbar__bar.is-vertical{
        background: #F5F5F5;
        border-radius: 2px;
        width: 3px;
        opacity: 1;
        margin-right: -2px;
    }
    .scrollbar ::v-deep .el-scrollbar__bar.is-horizontal{
        background: #F5F5F5;
        border-radius: 2px;
        height: 3px;
        margin-bottom: -2px;
        &:hover{
            opacity: 0;
        }
    }
    .tabs-area ::v-deep .el-tabs__header{
        margin: 0 0 0 !important;
    }
    .tabs-area ::v-deep .el-tabs__header .el-tabs__nav{
        border-radius: 0 !important;
    }
    .table ::v-deep .el-table__empty-block{
        min-height: 0 !important;
    }
    .table ::v-deep .el-table__empty-text{
        display: none;
    }
    ::v-deep {
        .el-rate__icon {
            font-size: 20px;
            margin-right: 2px;
        }

        .tabs-area {

            .el-tabs__nav {
                border-radius: 0;
            }

            .el-tabs__header {
                margin-bottom: 0;
            }

            .el-tabs__nav .el-tabs__item {
                width: 176px;
                text-align: center;
                font-size: 14px;
                line-height: 40px;
                height: 40px;

                &.is-active {
                    background: #F4F7FF;
                    color: #0064C8;
                }

                &.is-active::after {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    content: '';
                    width: 100%;
                    height: 2px;
                    background: #0064C8;
                }
            }
            .el-tabs__content{
                border-left:1px solid #ebeef5;
                border-right:1px solid #ebeef5;
                border-bottom:1px solid #ebeef5;
            }
        }
    }
</style>
